import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';

import { TASK_DATA } from '../../../core/contracts/task-data.contract';
import { Task, TaskType } from '../../../core/models/task.interface';
import { MultilineTextComponent } from '../../commons/multiline-text/multiline-text.component';
import { TaskDataTargetComponent } from '../../commons/task-data-target/task-data-target.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'tasks-service-request-task-summary',
  standalone: true,
  imports: [MatIcon, CdkOverlayOrigin, CdkConnectedOverlay, MatCard, MatCardContent, TaskDataTargetComponent, MultilineTextComponent, NgClass],
  template: `
    <div class='flex flex-col gap-1'>
      <tasks-task-data-target (click)='navigateToMemberProfile()'>
        <mat-icon icon>account_circle</mat-icon>
        <span text>{{ task.data.memberName }}</span>
      </tasks-task-data-target>
      @if (task.data.notes) {
        <div
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin"
          class='flex cursor-pointer items-center gap-1 text-neutral-500 hover:text-neutral-600'
          [ngClass]="{ 'text-neutral-600': notesOpen() }"
          (click)="notesOpen.set(!notesOpen())"
        >
          <p class='line-clamp-1'>{{ task.data.notes }}</p>
        </div>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="notesOpen()"
          [cdkConnectedOverlayHasBackdrop]="true"
          [cdkConnectedOverlayDisposeOnNavigation]="true"
          (backdropClick)="notesOpen.set(false)"
        >
          <mat-card class="w-96">
            <mat-card-content>
              <tasks-multiline-text [text]="task.data.notes" />
            </mat-card-content>
          </mat-card>
        </ng-template>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceRequestTaskSummaryComponent {
  protected readonly router = inject(Router);
  protected readonly task = inject<Task<TaskType.ServiceRequest>>(TASK_DATA);

  protected readonly notesOpen = signal<boolean>(false);

  protected navigateToMemberProfile(): void {
    this.router.navigate(['/members', this.task.data.memberId]);
  }
}
